@if (config) {
    <form [formGroup]="form.formGroup" nz-form>
        @switch (config.type) {
            @case ("number") {
                <pf-input
                    inputType="number"
                    [pfStyle]="pfStyle"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl"></pf-input>
            }
            @case ("textarea") {
                <pf-input
                    inputType="textarea"
                    [pfStyle]="pfStyle"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl"></pf-input>
            }
            @case ("boolean") {
                <pf-checkbox
                    [pfStyle]="pfStyle"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl">
                </pf-checkbox>
            }
            @case ("select") {
                <pf-select
                    [pfStyle]="pfStyle"
                    [data]="selectConfig.options || []"
                    [tree]="!!selectConfig.tree"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl">
                </pf-select>
            }
            @case ("date") {
                <pf-date-picker
                    [pfStyle]="pfStyle"
                    datePickerType="date"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl">
                </pf-date-picker>
            }
            @case ("datetime") {
                <pf-date-picker
                    [showTime]="true"
                    [pfStyle]="pfStyle"
                    datePickerType="date"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl">
                </pf-date-picker>
            }
            @default {
                <pf-input
                    inputType="text"
                    [pfStyle]="pfStyle"
                    [pfDisabled]="!!config.readonly"
                    [label]="config.label || ''"
                    [tooltip]="config.tooltip"
                    [control]="valueControl">
                </pf-input>
            }
        }
    </form>
}
